import { useSelector } from "react-redux";

export const BlogCardAnimation = ({ color }) => {
  const { skin } = useSelector((state) => state.header);

  const colors = {
      green: "#25C660",
      yellow: "#FFD500",
      blue: "#1BA3A8",
      gray: "#9E9E9E"
  };

  const activeColor = colors[color];

  return (
    <svg className="blog-card-animation" width="384" height="110" viewBox="0 0 384 110" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M322.5 3.21867e-06V11.4529C322.5 13.662 320.709 15.4529 318.5 15.4529L269.893 15.4529C267.684 15.4529 265.893 17.2437 265.893 19.4529V52.5614C265.893 54.7706 264.102 56.5614 261.893 56.5614L239.603 56.5614H227.358C225.149 56.5614 223.358 54.7706 223.358 52.5614V27.8688C223.358 25.6597 221.568 23.8688 219.358 23.8688H202.991C200.782 23.8688 198.991 22.0779 198.991 19.8688V19.4529C198.991 17.2437 197.2 15.4529 194.991 15.4529H151.21C149.001 15.4529 147.21 17.2437 147.21 19.4529V68.0985C147.21 70.3076 145.419 72.0985 143.21 72.0985L121.766 72.0985C119.557 72.0985 117.766 70.3077 117.766 68.0985V58.6193C117.766 56.4101 115.975 54.6193 113.766 54.6193H88.3223L37 54.6193C34.7909 54.6193 33 56.4101 33 58.6193V101"
        stroke={`url(#paint0_linear_${color})`} />
      <path
        d="M322.5 0.000125289V11.453C322.5 13.6621 320.709 15.453 318.5 15.453L269.893 15.453C267.684 15.453 265.893 17.2439 265.893 19.453V52.5615C265.893 54.7707 264.102 56.5615 261.893 56.5615L239.603 56.5615H227.358C225.149 56.5615 223.358 54.7707 223.358 52.5615V27.8689C223.358 25.6598 221.568 23.8689 219.358 23.8689H202.991C200.782 23.8689 198.991 22.0781 198.991 19.8689V19.453C198.991 17.2439 197.2 15.453 194.991 15.453H151.21C149.001 15.453 147.21 17.2439 147.21 19.453V68.0986C147.21 70.3078 145.419 72.0986 143.21 72.0986L121.766 72.0986C119.557 72.0986 117.766 70.3078 117.766 68.0986V58.6194C117.766 56.4103 115.975 54.6194 113.766 54.6194H88.3223L37 54.6194C34.7909 54.6194 33 56.4103 33 58.6194V101"
        stroke={`url(#paint1_linear_${color})`} strokeWidth="0.5"/>
      <path
        d="M0 38.5L58.9781 38.5C61.1873 38.5 62.9781 36.7091 62.9781 34.5V24.5C62.9781 22.2909 64.769 20.5 66.9781 20.5L134.293 20.5C136.502 20.5 138.293 22.2909 138.293 24.5V61.5C138.293 63.7091 140.084 65.5 142.293 65.5H240"
        stroke={`url(#paint2_linear_${color})`} />
      <path
        d="M0 38.5L58.9781 38.5C61.1873 38.5 62.9781 36.7091 62.9781 34.5V24.5C62.9781 22.2909 64.769 20.5 66.9781 20.5L134.293 20.5C136.502 20.5 138.293 22.2909 138.293 24.5V61.5C138.293 63.7091 140.084 65.5 142.293 65.5H240"
        stroke={`url(#paint3_linear_${color})`} strokeWidth="0.5"/>
      <path
        d="M24 90.8459L55.7447 90.8459C57.9538 90.8459 59.7447 89.0551 59.7447 86.8459V84.5C59.7447 82.2909 61.5355 80.5 63.7447 80.5H119.523C121.385 80.5 122.894 82.0089 122.894 83.8703V83.8703C122.894 85.7316 124.403 87.2405 126.264 87.2405L188 87.2405C190.209 87.2405 192 89.0314 192 91.2405V109.5"
        stroke={`url(#paint4_linear_${color})`} />
      <path
        d="M24 90.8459L55.7447 90.8459C57.9538 90.8459 59.7447 89.0551 59.7447 86.8459V84.5C59.7447 82.2909 61.5355 80.5 63.7447 80.5H119.523C121.385 80.5 122.894 82.0089 122.894 83.8703V83.8703C122.894 85.7316 124.403 87.2405 126.264 87.2405L188 87.2405C190.209 87.2405 192 89.0314 192 91.2405V109.5"
        stroke={`url(#paint5_linear_${color})`} strokeWidth="0.5"/>
      <path d="M166 109.5V84.5C166 82.2909 167.791 80.5 170 80.5L356 80.5" stroke={`url(#paint6_linear_${color})`}/>
      <path d="M166 109.5V84.5C166 82.2909 167.791 80.5 170 80.5L356 80.5" stroke={`url(#paint7_linear_${color})`}
            strokeWidth="0.5"/>
      <path d="M169.498 57.7744H192.249C194.458 57.7744 196.249 55.9836 196.249 53.7744L196.249 31.7304"
            stroke={`url(#paint8_linear_${color})`} />
      <path
        d="M384 89.5L250 89.5C247.791 89.5 246 87.7091 246 85.5L246 20.5C246 18.2909 244.209 16.5 242 16.5H238.5C236.291 16.5 234.5 18.2909 234.5 20.5V66L234.5 76.5C234.5 78.7091 232.709 80.5 230.5 80.5L170.5 80.5C168.291 80.5 166.5 82.2909 166.5 84.5V109"
        stroke={`url(#paint9_linear_${color})`}/>
      <path
        d="M384 89.5L250 89.5C247.791 89.5 246 87.7091 246 85.5L246 20.5C246 18.2909 244.209 16.5 242 16.5H238.5C236.291 16.5 234.5 18.2909 234.5 20.5V66L234.5 76.5C234.5 78.7091 232.709 80.5 230.5 80.5L170.5 80.5C168.291 80.5 166.5 82.2909 166.5 84.5V109"
        stroke={`url(#paint10_linear_${color})`} strokeWidth="0.5"/>
      <circle cx="0.833333" cy="0.833333" r="0.5" transform="matrix(1 0 0 -1 104.666 55.3335)" fill={activeColor}
              stroke={activeColor} strokeWidth="0.666667"/>
      <circle cx="2.5" cy="2.5" r="2.375" transform="matrix(1 0 0 -1 103 57)" stroke={activeColor} strokeWidth="0.25"/>
      <circle cx="0.833333" cy="0.833333" r="0.5" transform="matrix(1 0 0 -1 233.666 25.333)" fill="#1D1D1D"
              stroke="#1D1D1D" strokeWidth="0.666667"/>
      <circle cx="2.5" cy="2.5" r="2.375" transform="matrix(1 0 0 -1 232 27)" stroke="#1D1D1D" strokeWidth="0.25"/>
      <defs>
        {skin === "light" ? (
          <>
              <linearGradient id={`paint0_linear_${color}`} x1="9.5" y1="76.4999" x2="325.649" y2="-45.982"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor="#E2E2E2" stopOpacity="0"/>
                  <stop offset="0.505" stopColor="#E2E2E2"/>
                  <stop offset="1" stopColor="#E2E2E2" stopOpacity="0"/>
              </linearGradient>

              <linearGradient id={`paint1_linear_${color}`} x1="51" y1="82.5" x2="93.0586" y2="50.6534"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor={activeColor} stopOpacity="0"/>
                  <stop offset="0.505" stopColor={activeColor}/>
                  <stop offset="1" stopColor={activeColor} stopOpacity="0"/>
              </linearGradient>

              <linearGradient id={`paint2_linear_${color}`} x1="-7.91416" y1="57.5149" x2="253.726" y2="71.0333"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor="#E2E2E2" stopOpacity="0"/>
                  <stop offset="0.525" stopColor="#E2E2E2"/>
                  <stop offset="1" stopColor="#E2E2E2" stopOpacity="0"/>
              </linearGradient>

              <linearGradient id={`paint3_linear_${color}`} x1="33" y1="47.5" x2="89.9372" y2="29.5616"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor={activeColor} stopOpacity="0"/>
                  <stop offset="0.525" stopColor={activeColor}/>
                  <stop offset="1" stopColor={activeColor} stopOpacity="0"/>
              </linearGradient>

              <linearGradient id={`paint4_linear_${color}`} x1="28.1702" y1="115.944" x2="177.597" y2="23.9032"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor="#E2E2E2" stopOpacity="0"/>
                  <stop offset="0.505" stopColor="#E2E2E2"/>
                  <stop offset="1" stopColor="#E2E2E2" stopOpacity="0"/>
              </linearGradient>

              <linearGradient id={`paint5_linear_${color}`} x1="90.5" y1="91.5" x2="156.852" y2="41.5728"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor={activeColor} stopOpacity="0"/>
                  <stop offset="0.505" stopColor={activeColor}/>
                  <stop offset="1" stopColor={activeColor} stopOpacity="0"/>
              </linearGradient>

              <linearGradient id={`paint6_linear_${color}`} x1="257.5" y1="105.5" x2="280.12" y2="63.2091"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor="#E2E2E2" stopOpacity="0"/>
                  <stop offset="0.5" stopColor="#E2E2E2"/>
                  <stop offset="1" stopColor="#E2E2E2" stopOpacity="0"/>
              </linearGradient>

              <linearGradient id={`paint7_linear_${color}`} x1="243" y1="63.5" x2="277.369" y2="41.0515"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor={activeColor} stopOpacity="0"/>
                  <stop offset="0.5" stopColor={activeColor}/>
                  <stop offset="1" stopColor={activeColor} stopOpacity="0"/>
              </linearGradient>

              <linearGradient id={`paint8_linear_${color}`} x1="154.739" y1="68.8431" x2="172.104" y2="23.3121"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor="#E2E2E2" stopOpacity="0"/>
                  <stop offset="0.47" stopColor="#E2E2E2"/>
                  <stop offset="1" stopColor="#E2E2E2" stopOpacity="0"/>
              </linearGradient>

              <linearGradient id={`paint9_linear_${color}`} x1="357.5" y1="19.5" x2="238.073" y2="-41.8955"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor="#E2E2E2" stopOpacity="0"/>
                  <stop offset="0.5" stopColor="#E2E2E2"/>
                  <stop offset="1" stopColor="#E2E2E2" stopOpacity="0"/>
              </linearGradient>

              <linearGradient id={`paint10_linear_${color}`} x1="201" y1="93.5" x2="245.666" y2="77.9352"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor={activeColor} stopOpacity="0"/>
                  <stop offset="0.5" stopColor={activeColor}/>
                  <stop offset="1" stopColor={activeColor} stopOpacity="0"/>
              </linearGradient>
          </>
        ) : (
          <>
              <linearGradient id={`paint0_linear_${color}`} x1="9.5" y1="76.4999" x2="325.649" y2="-45.982"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor="#1D1D1D" stopOpacity="0"/>
                  <stop offset="0.505" stopColor="#1D1D1D"/>
                  <stop offset="1" stopColor="#1D1D1D" stopOpacity="0"/>
              </linearGradient>
              <linearGradient id={`paint1_linear_${color}`} x1="51" y1="82.5" x2="93.0586" y2="50.6534"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor={activeColor} stopOpacity="0"/>
                  <stop offset="0.505" stopColor={activeColor}/>
                  <stop offset="1" stopColor={activeColor} stopOpacity="0"/>
              </linearGradient>
              <linearGradient id={`paint2_linear_${color}`} x1="-7.91416" y1="57.5149" x2="253.726" y2="71.0333"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor="#1D1D1D" stopOpacity="0"/>
                  <stop offset="0.525" stopColor="#1D1D1D"/>
                  <stop offset="1" stopColor="#1D1D1D" stopOpacity="0"/>
              </linearGradient>
              <linearGradient id={`paint3_linear_${color}`} x1="33" y1="47.5" x2="89.9372" y2="29.5616"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor={activeColor} stopOpacity="0"/>
                  <stop offset="0.525" stopColor={activeColor}/>
                  <stop offset="1" stopColor={activeColor} stopOpacity="0"/>
              </linearGradient>
              <linearGradient id={`paint4_linear_${color}`} x1="28.1702" y1="115.944" x2="177.597" y2="23.9032"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor="#1D1D1D" stopOpacity="0"/>
                  <stop offset="0.505" stopColor="#1D1D1D"/>
                  <stop offset="1" stopColor="#1D1D1D" stopOpacity="0"/>
              </linearGradient>
              <linearGradient id={`paint5_linear_${color}`} x1="90.5" y1="91.5" x2="156.852" y2="41.5728"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor={activeColor} stopOpacity="0"/>
                  <stop offset="0.505" stopColor={activeColor}/>
                  <stop offset="1" stopColor={activeColor} stopOpacity="0"/>
              </linearGradient>
              <linearGradient id={`paint6_linear_${color}`} x1="257.5" y1="105.5" x2="280.12" y2="63.2091"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor="#1D1D1D" stopOpacity="0"/>
                  <stop offset="0.5" stopColor="#1D1D1D"/>
                  <stop offset="1" stopColor="#1D1D1D" stopOpacity="0"/>
              </linearGradient>
              <linearGradient id={`paint7_linear_${color}`} x1="243" y1="63.5" x2="277.369" y2="41.0515"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor={activeColor} stopOpacity="0"/>
                  <stop offset="0.5" stopColor={activeColor}/>
                  <stop offset="1" stopColor={activeColor} stopOpacity="0"/>
              </linearGradient>
              <linearGradient id={`paint8_linear_${color}`} x1="154.739" y1="68.8431" x2="172.104" y2="23.3121"
                              gradientUnits="userSpaceOnUse">
                  <stop stopColor="#1D1D1D" stopOpacity="0"/>
              <stop offset="0.47" stopColor="#1D1D1D"/>
              <stop offset="1" stopColor="#1D1D1D" stopOpacity="0"/>
            </linearGradient>
            <linearGradient id={`paint9_linear_${color}`} x1="357.5" y1="19.5" x2="238.073" y2="-41.8955"
                            gradientUnits="userSpaceOnUse">
              <stop stopColor="#1D1D1D" stopOpacity="0"/>
              <stop offset="0.5" stopColor="#1D1D1D"/>
              <stop offset="1" stopColor="#1D1D1D" stopOpacity="0"/>
            </linearGradient>
            <linearGradient id={`paint10_linear_${color}`} x1="201" y1="93.5" x2="245.666" y2="77.9352"
                            gradientUnits="userSpaceOnUse">
              <stop stopColor={activeColor} stopOpacity="0"/>
              <stop offset="0.5" stopColor={activeColor}/>
              <stop offset="1" stopColor={activeColor} stopOpacity="0"/>
            </linearGradient>
          </>
        )}
      </defs>
    </svg>
  );
};
